'use strict';

var box = {};

exports.__exports = box;
//# sourceMappingURL=box.cjs.map
